// Carrier tokens are sha256(companyId-orderId) as hex. Old links
// (documents.cargotic.app) carry the same token as new ones, so a pasted link
// from either portal, or the bare token, resolves on this portal.
const TOKEN_PATTERN = /^[0-9a-f]{64}$/i;

const parseDocumentsToken = (input) => {
  const text = (input || "").trim();

  if (TOKEN_PATTERN.test(text)) {
    return text.toLowerCase();
  }

  const match = text.match(/[?&]token=([^&#\s]+)/);
  if (!match) {
    return undefined;
  }

  let token;
  try {
    token = decodeURIComponent(match[1]);
  } catch (error) {
    return undefined;
  }

  return TOKEN_PATTERN.test(token) ? token.toLowerCase() : undefined;
};

export default parseDocumentsToken;
